export const appPeople = "OmoxS";
export default {appPeople};